import { useContext, useEffect, useState } from "react";
import useRenderOnDemand from "../../utils/useRenderOnDemand";
import { ImageFormat, ImageType, ImageStatus, ImageRequest } from "../../utils/useRenderOnDemand.types";
import useRenderConfig from "../../utils/useRenderConfig";
import DataContainer from "../../services/DataContainer";
import { useWrap } from "../../utils/useWrap";
import SliderTpl from "./SliderTpl";
import { MarketSettings, RodSettings } from "../../enum/enums";
import { DataContainerContext } from "../../context/DataContainerContext";
import { useParams } from "react-router-dom";

interface SliderProps{
  onSummary: boolean;
  environment?: string;
}

const Slider = ({onSummary, environment}: SliderProps) => {
  const [page, setPage] = useState<number>(0);
  const [hasTimedOut, setHasTimedOut] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentSource, setCurrentSource] = useState("");
  const {activeComponent, activeComponentGroups} = useContext(DataContainerContext);
  const exteriorViewPoints = DataContainer.getProductViewPoints() && DataContainer.getProductViewPoints().map((vp: { name: string }) => vp.name);
  const {modelName} = useParams();
  const {modelNameFromUrl} = useParams();

  const paginate = (newDirection: number) => {
    if (exteriorViewPoints)  setPage(useWrap(0, exteriorViewPoints.length - 1, page + newDirection));
  };

  const steeringwheel_position = DataContainer.sectionKey(MarketSettings.MARKET_SETTINGS, MarketSettings.STEERINGWHEEL_POSITION);

  const renderConfig = useRenderConfig();
  const [currentViewpoint, setCurrentViewpoint] = useState(`${exteriorViewPoints[page]}`);
  useEffect(() => {
    if (activeComponentGroups.name === "Interior") {
      if(activeComponent.name === "Int_trim_levels") {
        setCurrentViewpoint("driverView");
      }
      else if(activeComponent.name === "Seats") {
        setCurrentViewpoint("bedView");
      }
    } else {
      setCurrentViewpoint(`${exteriorViewPoints[page]}`);
    }

    if(onSummary) {
      setCurrentViewpoint(`${exteriorViewPoints[page]}`);
    }
  }, [activeComponent, activeComponentGroups, page]);

  const renderSpec: ImageRequest = {
    sequence: currentViewpoint,
    attributes: {
      steeringwheel_position: steeringwheel_position,
      stage: environment
    },
    renderVersion: parseInt(DataContainer.sectionKey(RodSettings.ROD_SETTINGS, `${modelName ? modelName.split("_")[0] : modelNameFromUrl?.split("_")[0]}_renderversion`)),
    configuration: renderConfig,
    format: ImageFormat.JPEG,
    width: 2500,
    height: 1875,
    type: ImageType.Image,
    compressionQuality: 100,
  };

  const imageInformation = useRenderOnDemand(renderSpec);

  const anglesHash = exteriorViewPoints && exteriorViewPoints.join(",");

  useEffect(() => {
    setIsLoading(true);
    if (imageInformation.status === ImageStatus.Ready) {
      setIsLoading(false);
    }
  }, [imageInformation]);

  useEffect(()=> {
    setCurrentSource(imageInformation.urlAssets[0]);
  },[imageInformation]);


  useEffect(() => {
    if (imageInformation.status === ImageStatus.Timeout) {
      setHasTimedOut(true);
      setIsLoading(false);
    } else if (hasTimedOut) {
      setHasTimedOut(false);
    }
  }, [imageInformation]);

  useEffect(() => {
    setPage(0);
  }, [anglesHash]);

  return (
    <SliderTpl
      page={page}
      setPage={setPage}
      paginate={paginate}
      setIsLoading={setIsLoading}
      isLoading={isLoading}
      currentSource={currentSource}
      setImageSource={setCurrentSource}
      exteriorViewPoints={exteriorViewPoints}
      onSummary={onSummary}
      setHasTimedOut={setHasTimedOut}
      showError={hasTimedOut}
      renderSpec={renderSpec}
    />
  );
};

export default Slider;
